import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import { get } from 'lodash'
import { removeSpaces } from 'Helpers/StringHelpers'

// USHOP-3031 — markets that opt out of the Smarty (SmartyStreets) address lookup.
// Taiwan: Smarty returns a 5-digit TW zip while the order API accepts 3, so the
// customer types the whole address (zip included) by hand. Every other market
// keeps the AutoAddress field exactly as the published form config declares it.
const COUNTRIES_WITHOUT_AUTO_ADDRESS = ['TWN']

export const isAutoAddressDisabled = () => COUNTRIES_WITHOUT_AUTO_ADDRESS.includes(storeCountry.Country3())

export const resolveFieldType = (forceType, item) => {
    const fieldType = forceType || item?.type || 'default'

    if (fieldType === 'AutoAddress' && isAutoAddressDisabled()) {
        return 'default'
    }

    return fieldType
}

export const resolveDefaultInputType = item => {
    if (!item) return 'text'

    if (['zip_code', 'zip', 'phone', 'cvv', 'card_number'].includes(item.key)) {
        return 'tel'
    }

    if (item.key === 'email') {
        return 'email'
    }

    return 'text'
}

export const sanitizeNumericValue = value => (value || '').replace(/[^0-9]/g, '')

export const shouldRenderStateSelect = item => {
    if (!item) return false

    const country = storeCountry.Country3()
    const isState = item.key === 'state'
    const isDistrict = item.key === 'district' && !['JPN', 'EGY', 'JOR', 'THA'].includes(country)
    const isPrefecture = item.key === 'prefecture'

    return isState || isDistrict || isPrefecture
}

export const shouldRenderCitySelect = item => {
    if (!item) return false

    const country = storeCountry.Country3()
    return item.key === 'city' && ['TWN', 'EGY'].includes(country)
}

export const shouldRenderThaiFullName = item => {
    if (!item) return false

    const isFullNameKey = item.key === 'fullName' || item.key === 'fullNameNative'
    return isFullNameKey && StoreCountry.Country3() === 'THA'
}

export const preventEmailSpace = (item, event) => {
    if (item.key === 'email' && event.key === ' ') {
        event.preventDefault()
    }
}

export const callOnChangeOrSetCheckout = (item, payload, onChange) => {
    if (onChange) {
        onChange(item, payload)
        return
    }

    StoreCheckout.SetCheckoutFormValue(item.key, payload)
}

export const handleDefaultInputChange = ({ item, event, onChange }) => {
    if (!item) return

    if (onChange) {
        onChange(item, event)
        return
    }

    const value = event.target.value

    if (!value.length) {
        StoreCheckout.SetCheckoutFormValue(item.key, '')
        return
    }

    const regx = get(item, 'args.regx', null)

    if (regx) {
        const regex = new RegExp(regx, 'i')
        if (regex.test(value)) {
            StoreCheckout.SetCheckoutFormValue(item.key, value)
        }
    } else {
        StoreCheckout.SetCheckoutFormValue(item.key, value)
    }
}

export const handleBlurRemoveSpaces = (item, event) => {
    if (!item) return

    StoreCheckout.SetCheckoutFormValue(item.key, removeSpaces(event.target.value, item.key))
}

